export const guestContactRetentionDays = 60;
export const privacyController = "Ascent Media";
export const privacyEmail = "th.ascent.media@gmail.com";
